// extracted by mini-css-extract-plugin
module.exports = {"row":"AdminSearch_row__18nr4"};